export const APP_PREFIX = window._env_.PUBLIC_URL;
